<template>
  <div class="bravado-trustpilot-badge flex items-center relative mb9 clickable">
    <span class="mr3">Excellent</span>
    <img
      class="mr3"
      src="@/components/global/Badges/assets/trust-pilot-rating.svg"
      alt="Trust Pilot rating by starts"
      width="110"
      height="20"
      loading="lazy"
      decoding="async"
    />

    <img
      src="@/components/global/Badges/assets/trust-pilot-logo.svg"
      alt="Trust Pilot logo"
      width="18"
      height="18"
      loading="lazy"
      decoding="async"
    />
    <span class="ml1">Trustpilot</span>
  </div>
</template>

<script>
export default {
  name: 'BravadoTrustpilotBadge',
};
</script>

<style lang="scss" scoped>
.bravado-trustpilot-badge {
  color: $white;
  font-size: 16px;
  height: 20px;
  line-height: 14px;
  z-index: 11;

  span {
    opacity: 0.4;
  }
}
</style>
